import { type ReactNode } from 'react'
import { isNotEmpty } from '@terros/common'
import { Box, Group, Stack } from '@mantine/core'
import { SizePrimitives } from '@front/model'
import { PreviewReviews } from './PreviewReviews'
import { PreviewProfileColumn } from './PreviewProfileColumn'
import { PreviewGallery } from './PreviewGallery'
import { type CardPreviewProps, toBannerGradient } from './previewContent'

const BANNER_HEIGHT = 144
const PROFILE_COLUMN_WIDTH = 320

export const DesktopCardPreview = ({ content, tokens }: CardPreviewProps): ReactNode => (
  <Box bg={tokens.page} pb='xl'>
    <Box bg={tokens.banner} h={BANNER_HEIGHT} style={{ backgroundImage: toBannerGradient(tokens) }} />
    <Group align='flex-start' gap='xl' px='lg' wrap='nowrap'>
      <Box mt={-SizePrimitives['16']} w={PROFILE_COLUMN_WIDTH}>
        <PreviewProfileColumn content={content} tokens={tokens} />
      </Box>
      <Stack flex={1} gap='xl' pt='xl'>
        {isNotEmpty(content.gallery) && <PreviewGallery images={content.gallery} ink={tokens.ink} layout='desktop' />}
        {content.showReviews && (
          <PreviewReviews
            hasGoogleBusinessProfile={content.hasGoogleBusinessProfile}
            rating={content.rating}
            reviewCount={content.reviewCount}
            review={content.review}
            tokens={tokens}
          />
        )}
      </Stack>
    </Group>
  </Box>
)
